// extracted by mini-css-extract-plugin
module.exports = {"unitWaitingPage":"index_unitWaitingPage_1OBkP","loadingIcon":"index_loadingIcon_2vASw","title":"index_title_3azPr","desc":"index_desc_151Po"};